/**
 * Centralized URL query-parameter names used across pages.
 *
 * Producers and consumers must reference these constants rather than
 * hardcoding the literal string so a rename here propagates everywhere.
 */
export const CREATE_FLAG_PARAM = 'create';

/**
 * Query-param name that selects which tab is active on the project Settings
 * page (e.g. `?tab=freeGrants`). Lets other surfaces deep-link straight to a
 * specific Settings tab.
 */
export const SETTINGS_TAB_PARAM = 'tab';

/** Settings tab values. Referenced by both the Settings page and deep-links to it. */
export const SETTINGS_TAB = {
  permissions: 'permissions',
  observability: 'observability',
  freeGrants: 'freeGrants',
} as const;

export type SettingsTab = (typeof SETTINGS_TAB)[keyof typeof SETTINGS_TAB];
